export default __webpack_public_path__ + "static/media/pat_mahomes.02370805.png";